import { useCredentialingTranslation } from './useCredentialingTranslation';
export function useQualificationFilters() {
    const { t } = useCredentialingTranslation();
    const qualificationFilters = (builder) => {
        builder.allFiltersPanel({
            key: '!qualification',
            label: t('filters.qualifications.groupTitle'),
            children: [
                builder.allFiltersWidget({
                    label: t('filters.qualifications.skill'),
                    type: 'form.multiSelect',
                    key: 'skillIds',
                    valueProvider: {
                        type: 'classifier.skill',
                    },
                }),
                builder.allFiltersWidget({
                    label: t('filters.qualifications.language'),
                    type: 'form.multiSelect',
                    key: 'languageIds',
                    valueProvider: {
                        type: 'classifier.language',
                    },
                }),
                builder.allFiltersWidget({
                    label: t('filters.qualifications.coursesTitle'),
                    type: 'form.multiSelect',
                    key: 'trainingCourseIds',
                    valueProvider: {
                        type: 'classifier.training',
                    },
                }),
                builder.allFiltersWidget({
                    label: t('filters.qualifications.statusTitle'),
                    type: 'form.multiSelect',
                    key: 'trainingStatusSet',
                    values: verificationStatusValues,
                }),
            ],
        });
    };
    return { qualificationFilters };
}
export const verificationStatusValueLabel = {
    expired: 'Expired',
    failed: 'Failed',
    notChecked: 'Not Checked',
    success: 'Success',
    unknown: 'Unknown',
};
export const verificationStatusValues = Object.entries(verificationStatusValueLabel).map((entry) => ({
    value: entry[0],
    label: entry[1],
}));
